import { ReactElement } from 'react'
import { useParams } from 'react-router'
import { ProjectApplicationAssessmentExclusion } from 'src/screens/shared/application/assessment/details/exclusion/ProjectApplicationAssessmentExclusion'

export const PfPgvExclusionPage = (): ReactElement => {
  const { projectId, assessmentId } = useParams()
  const pfPgvProjectId = parseInt(projectId as string)
  const pfPgvAssessmentId = parseInt(assessmentId as string)

  return (
    <ProjectApplicationAssessmentExclusion
      baseUrl="/pf-pgv"
      projectId={pfPgvProjectId}
      assessmentId={pfPgvAssessmentId}
    />
  )
}
